var tables = [
    {
        name: "Table C",
        image: "thumbnails/table C leg black Closeup.jpg",
        id: "blackC",
        link: "https://sobusobu.com/products/leviathan-dining-table?variant=7224726814767"
    },
    {
        name: "Table T Black",
        image: "thumbnails/table T leg black closeup.jpg",
        id: "blackT",
        link: "https://sobusobu.com/products/leviathan-dining-table?variant=40606336385173"
    },
    {
        name: "Table T Gold",
        image: "thumbnails/table T leg gold - closeup.jpg",
        id: "goldT",
        link: "https://sobusobu.com/products/leviathan-dining-table?variant=43944710963453"
    }
]


var chairs = [
    {
        name: "Copenhagen Black",
        image: "thumbnails/copenhagen black.jpg",
        id: "copenhagen-black",
        link: "https://sobusobu.com/collections/chairs/products/copenhagen-chair-black-ash"
    },
    {
        name: "Copenhagen Walnut",
        image: "thumbnails/copenhagen walnut.jpg",
        id: "copenhagen-walnut",
        link: "https://sobusobu.com/collections/chairs/products/copenhagen-chair-walnut"
    },
    {
        name: "Sven Black",
        image: "thumbnails/sven black.jpg",
        id: "sven-black",
        link: "https://sobusobu.com/collections/chairs/products/sven-chair-black-ash-black-leather-seat"
    },
    {
        name: "Sven Walnut",
        image: "thumbnails/sven walnut.jpg",
        id: "sven-walnut",
        link: "https://sobusobu.com/collections/chairs/products/sven-chair-walnut-leather-seat"
    }
]

var sizes = [
    {
        name: "78''",
        image: "thumbnails/78''.jpg",
        id: "78"
    },
    {
        name: "98''",
        image: "thumbnails/98''.jpg",
        id: "98"
    },
    {
        name: "118''",
        image: "thumbnails/118''.jpg",
        id: "118"
    }
]


export { tables, chairs, sizes }